import { render, staticRenderFns } from "./TasksDisplayGrid.vue?vue&type=template&id=7504f222&scoped=true"
import script from "./TasksDisplayGrid.vue?vue&type=script&lang=js"
export * from "./TasksDisplayGrid.vue?vue&type=script&lang=js"
import style0 from "./TasksDisplayGrid.vue?vue&type=style&index=0&id=7504f222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7504f222",
  null
  
)

export default component.exports